/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, computed, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PulseIconComponent } from 'src/chatbot/icons/send-icon/pulse-icon.component';
import { VoiceIconComponent } from 'src/chatbot/icons/send-icon/voice-icon.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RecordAudioHandlerService } from 'src/chatbot/service/recordAudioHandler.service';
import { MyHammerConfig } from 'src/app/config/hammer.config';
import { Subscription } from 'rxjs';
import { HammerLongPressDirective } from 'src/chatbot/directives/hammerLongPress.directive';
import { LoaderButtonComponent } from "../loaderButton/loaderButton.component";
import { LocalFillerPhrasesService } from 'src/chatbot/service/localFillerPhrases.service';
import { TranslateModule } from '@ngx-translate/core';
import { CancelButtonComponent } from '../cancelButton/cancelButton.component';

@Component({
  selector: 'voice-button',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    VoiceIconComponent,
    PulseIconComponent,
    HammerLongPressDirective,
    LoaderButtonComponent,
    CancelButtonComponent
],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig }],
  templateUrl: './voiceButton.component.html',
  styleUrl: './voiceButton.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceButtonComponent {
  @Output() public actionEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() chatForm!: FormGroup;

  private phrasesService = inject(LocalFillerPhrasesService);
  private recordService = inject(RecordAudioHandlerService);
  private dataChat = inject(DataChatService);

  public isRecording = computed(() => this.recordService.isRecording());
  public chatIsThinking = computed(() => this.dataChat.chatIsThinking());
  public isStreaming = computed(() => this.dataChat.isStreaming());
  public isPlayingWelcome = computed(() => this.phrasesService.isPlayingWelcome());
  public showRecordIcon = computed(() => this.recordService.isLongPressMode())
  public isInvalid = signal<boolean>(true);

  private formSub?: Subscription;

  ngOnInit(): void {
    this.isInvalid.set(this.chatForm.invalid);

    this.formSub = this.chatForm.valueChanges.subscribe(() => {
      this.isInvalid.set(this.chatForm.invalid);
    });
  }

  onShortTap(): void {
    this.recordService.isLongPressMode.set(false);
    if (this.isRecording()) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  onLongPressStart(): void {
    if (this.isRecording()) 
      return;
    
    this.recordService.isLongPressMode.set(true);
    this.startRecording();
  }

  onLongPressEnd(): void {
    this.recordService.isLongPressMode.set(false);
    if (!this.isRecording()) 
      return;

    this.stopRecording();
  }

  private startRecording(): void {
    this.dataChat.hasHistory.set(true);
    this.actionEmitter.emit('START');
  }

  public stopRecording(): void {
    this.recordService.isLongPressMode.set(false);
    this.actionEmitter.emit('STOP');
  }

  ngOnDestroy(): void {
    this.formSub?.unsubscribe();
  }

}